import React from 'react';
import cx from 'classnames';

import { sizeDown } from 'utils/components';

import Avatar, { AvatarLoading } from 'components/Avatar';
import { parseImageUrl } from 'utils/twitch';


export const GameCardLoading = ({game, className, size = 'm', layout = 'row',...props}) => (
  <div className={cx("g-game-card", "loading", className, size, layout)} {...props}>
    <AvatarLoading size={sizeDown(size)} />
    <div className="name loading-text" />
  </div>
);


export const GameCard = ({game, className, size = 'm', layout = 'row', showName = true, children, thumbWidth= 75, ...props}) => {
  let src = parseImageUrl(game?.thumbUrl, thumbWidth) ?? '/assets/images/default_avatar.png';

  if(!game)
    return(
    <div className={cx("g-game-card empty-game", className, size, layout)}>
      <div className={cx("g-gamethumb", size)} />
    </div>)

  return (
    <div className={cx("g-game-card", className, size, layout)} {...props}>
      <img src={src} className={cx("g-gamethumb", size)} />
      <div>
        { showName 
          ? <div className="name">{game?.name}</div>
          : null }
        { children 
          ? <div className="extra">{ children }</div>
          : null }
      </div>
    </div>
)};
export default GameCard;